var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState, useRef } from 'react';
/**
 * Unmount component after a specified time, which allows complex CSS animations to finish.
 *
 * @param isVisible Animated component basic visibility, change of this state triggers the animations
 * @param timeout Time in milliseconds after which component will unmount, CSS animation duration should be shorter than the timeout
 * @returns True or false, whether animation already finished or not
 */
function useAnimateTransition(isVisible, timeout) {
    var _a = __read(useState(false), 2), isAnimating = _a[0], setIsAnimating = _a[1];
    var isMounted = useRef(false);
    var animateStartTimer = useRef();
    var animateOutTimer = useRef();
    function clearTimers() {
        cancelAnimationFrame(Number(animateStartTimer.current));
        clearTimeout(Number(animateOutTimer.current));
    }
    useEffect(function () {
        isMounted.current = true;
        return function () {
            isMounted.current = false;
        };
    }, []);
    useEffect(function () {
        if (isVisible && isMounted) {
            clearTimers();
            animateStartTimer.current = requestAnimationFrame(function () {
                setIsAnimating(true);
            });
        }
        else {
            animateOutTimer.current = setTimeout(function () {
                setIsAnimating(false);
            }, timeout);
        }
        return function () {
            clearTimers();
        };
    }, [isVisible, timeout]);
    return isAnimating;
}
export default useAnimateTransition;
